import React from "react";
import {GridCell, gridConstants} from "../Grid";
import {SelectField, TextField} from "../Inputs";
import {ButtonIconSearch} from "../Inputs/Buttons/ButtonIcon/ButtonIcon";
import {CheckInVolumesTable} from "./CheckInVolumesTable";
import {CHECKIN_TYPES_LIST} from "./checkInConstants";

interface CheckInFormVolumeProps {
    checkInForm: Record<string, any>;
    handleSearchClick: () => void;
    processName?: string;
    searchResults?: Record<string, any>[];
}

export const CheckInFormVolume = ({
                                      checkInForm,
                                      handleSearchClick,
                                      processName = "Check In",
                                      searchResults,
                                  }: CheckInFormVolumeProps) => {

    const fillCheckedOutAccessNumber = (accessNumber: string) => {
        checkInForm.barcode.setValue(accessNumber);
    }

    const fillShelfLocation = (shelfLocation: string) => {
        checkInForm.shelfLocation.setValue(shelfLocation);
    }

    return <>
        <GridCell>
            <h2 className={'h3'}>{processName} Individual Volumes</h2>
        </GridCell>

        <TextField
            {...checkInForm.barcode}
            label="Access Number"
            small_columns={gridConstants.column.TEN}
        />

        <GridCell small_columns={gridConstants.column.TWO}>
            <ButtonIconSearch
                id={`searchAccessNumber`}
                inputDescription={`Search`}
                onClick={handleSearchClick}
            />
        </GridCell>

        {
            searchResults && searchResults.length > 0 &&
            <GridCell>
                <CheckInVolumesTable
                    volumesFound={searchResults}
                    fillCheckedOutAccessNumber={fillCheckedOutAccessNumber}
                    fillShelfLocation={fillShelfLocation}
                />
            </GridCell>
        }

        <TextField
            {...checkInForm.shelfLocation}
        />

        <SelectField
            {...checkInForm.status}
            options={CHECKIN_TYPES_LIST}
            includeDefaultOption={false}
        />
    </>
}

